import { ReactNode } from 'react';
import { Columns, Icon } from 'react-bulma-components';
import { FaChevronRight } from 'react-icons/fa6';
import If from '../../../shared/if/if';
import Button from '../../../ui/button/button';
import styles from './move-devices-option-item.module.scss';

export type MoveDevicesOptionItemProps = {
  icon: ReactNode;
  label: string;
  active: boolean;
  onClick: () => void;
  hasNestedSelection?: boolean;
};

export function MoveDevicesOptionItem({
  icon,
  label,
  active,
  onClick,
  hasNestedSelection = false,
}: MoveDevicesOptionItemProps) {
  return (
    <Button
      className={`${styles.optionButton} ${
        active ? styles.activeButton : styles.hoverableButton
      }`}
      onClick={onClick}
    >
      <Columns display="flex" className="w-full">
        <Columns.Column display="flex" paddingless alignItems="flex-start">
          <Icon color={active ? 'white' : 'primary-dark'}>{icon}</Icon>
          <span className={active ? 'has-text-white' : 'has-text-primary-dark'}>
            {label}
          </span>
        </Columns.Column>
        <If condition={hasNestedSelection}>
          <Columns.Column display="flex" paddingless justifyContent="flex-end">
            <Icon color={active ? 'white' : 'primary-dark'}>
              <FaChevronRight />
            </Icon>
          </Columns.Column>
        </If>
      </Columns>
    </Button>
  );
}

export default MoveDevicesOptionItem;
